import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import "./components.css";
import { getLocalizedFieldLabel } from "../helpers/helpers";
import { formatPhoneNumber } from "../utils/phoneFormatter";

export default function TextFieldComponent(props) {
  const { questionKey, value, onChange, error, helperText, maxLength, label, lang } = props;
  const [displayValue, setDisplayValue] = useState(value || "");

  useEffect(() => {
    if (questionKey === 'phoneNumber') {
      setDisplayValue(formatPhoneNumber(value || ""));
    } else {
      setDisplayValue(value || "");
    }
  }, [value, questionKey]);

  const handleChange = (e) => {
    let newValue = e.target.value;
    if (questionKey === 'firstName' || questionKey === 'lastName') {
      newValue = newValue.replace(/[^a-zA-Z\s'-]/g, "");
    } else if (questionKey === 'phoneNumber') {
      // Format phone number as user types
      const formatted = formatPhoneNumber(newValue);
      setDisplayValue(formatted);
      // Store the formatted value (validation will handle it)
      newValue = formatted;
    }
    onChange(questionKey, newValue);
  };

  return (
    <div className="flexAlignColumnClassName">
      <TextField
        label={getLocalizedFieldLabel(questionKey, lang) || label}
        autoComplete="off"
        id={`outlined-text-${questionKey}`}
        className={`textFieldInputComponent ${error ? 'error' : ''}`}
        value={displayValue}
        onChange={handleChange}
        error={!!error}
        helperText={helperText}
        inputProps={{ maxLength: questionKey === 'phoneNumber' ? 14 : maxLength }}
        InputProps={{
          classes: {
            root: `outlinedInputRoot ${error ? 'error' : ''}`,
            focused: `outlinedInputFocused ${error ? 'error' : ''}`,
            notchedOutline: "outlinedInput",
          },
        }}
        InputLabelProps={{
          classes: {
            root: "outlinedInputLabel",
            focused: "focusedInputLabel",
        
          }
        }}
      />
    </div>
  );
}
